import React, { useMemo } from "react";
import BaseSwingTable from "./BaseSwingTable";
import CollectionsRow from "./CollectionsRow/CollectionsRow";
import { useSwingList } from "../../hooks/useSwingList";
import { useSwingTableColumns } from "../../hooks/useSwingTableColumns";
import { useSwingLibraryStore } from "../../store/swingLibraryStore";
import { useUserData } from "../../../../hooks/useUserData";
import { useUserSubscriptionAddons } from "../../../../hooks/useUserSubscriptionAddons";

export default function SwingTable() {
  const { data: swingListData } = useSwingList();
  const { selectedVideos, quickCompareCollection1 } = useSwingLibraryStore();
  const { userData } = useUserData();
  const { llmAddon } = useUserSubscriptionAddons();
  const isAdmin = userData?.role === "admin";
  const canUseCollections = isAdmin || llmAddon;

  const columns = useSwingTableColumns({
    videoPathAction: "checkbox",
  });

  const selectedTableData = useMemo(() => {
    if (!selectedVideos) return [];
    return Object.values(selectedVideos);
  }, [selectedVideos]);

  const tableColumns = columns ?? [];

  const CollectionsRowComponent = useMemo(() => {
    const hasSelection =
      Array.isArray(selectedTableData) && selectedTableData.length > 0;

    if ((!hasSelection && !quickCompareCollection1) || !canUseCollections) {
      return null;
    }
    function CollectionsRowWrapper() {
      return (
        <CollectionsRow
          columnsLength={tableColumns.length}
          selectedTableData={selectedTableData}
        />
      );
    }

    return CollectionsRowWrapper;
  }, [
    selectedTableData,
    tableColumns.length,
    quickCompareCollection1,
    canUseCollections,
  ]);

  return (
    <BaseSwingTable
      averages={swingListData?.averages}
      additionalRows={[CollectionsRowComponent]}
      allVideos={swingListData?.videos || []}
      columns={tableColumns}
      enableRowSelection={true}
      showPagination={true}
    />
  );
}
